import React from 'react'
import axios from 'axios'

// Settings → Account → Emails. The one consent switch for lifecycle emails
// (product tips, onboarding, win-back), stored on the user's profile as
// emailOptIn. Null in the profile means never asked, which the product
// treats as opted in; the switch shows that state honestly as on.
export default function EmailPreferencesBlock() {
    const [optIn, setOptIn] = React.useState(null) // null until loaded
    const [state, setState] = React.useState('loading') // loading | idle | saving | failed | unavailable

    React.useEffect(() => {
        axios
            .get('/me/profile')
            .then(response => {
                const profile = response.data && response.data.profile
                setOptIn(profile && profile.emailOptIn === false ? false : true)
                setState('idle')
            })
            .catch(() => setState('unavailable'))
    }, [])

    async function toggle() {
        const next = !optIn
        setOptIn(next)
        setState('saving')
        try {
            await axios.patch('/me/profile', { emailOptIn: next })
            setState('idle')
        } catch (error) {
            setOptIn(!next)
            setState('failed')
        }
    }

    if (state === 'loading' || state === 'unavailable') return null

    return (
        <div className="project-notes-scope">
            <section
                className="tw-my-4 tw-max-w-[800px] tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-card tw-p-4"
                data-testid="account-email-block"
            >
                <h3 className="tw-m-0 tw-mb-1 tw-text-base tw-font-semibold">
                    Emails
                </h3>
                <label className="tw-flex tw-cursor-pointer tw-items-start tw-gap-3">
                    <input
                        type="checkbox"
                        role="switch"
                        aria-checked={optIn}
                        checked={optIn}
                        onChange={toggle}
                        disabled={state === 'saving'}
                        data-testid="account-email-opt-in"
                        className="tw-mt-1 tw-h-4 tw-w-4 tw-cursor-pointer"
                    />
                    <span>
                        <span className="tw-block tw-text-sm tw-font-medium">
                            Product tips and onboarding emails
                        </span>
                        <span className="tw-block tw-text-sm tw-text-muted-foreground">
                            Short emails about what you can do with your graphs.
                            Billing and account emails are sent either way.
                        </span>
                    </span>
                </label>
                {state === 'failed' ? (
                    <p
                        className="tw-m-0 tw-mt-2 tw-text-sm tw-text-destructive"
                        role="alert"
                        data-testid="account-email-error"
                    >
                        We could not save that. Please try again.
                    </p>
                ) : null}
            </section>
        </div>
    )
}
